import { AxiosPromise } from 'axios';

import { Iso8601DateTimeString } from '../../../../types/Iso8601DateTimeString';
import { MoneyMessage } from '../../../../types/MoneyMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface ExportOfferAsPdfParams {
    id: string;
}

interface ExportOrderAsPdfParams {
    id: string;
}

interface RfqExportItem {
    productId?: string;
    baseProductId?: string;
    packType?: string;
    unitSize?: number;
    units?: number;
    unit?: string;
    volume?: number;
    deleted: boolean;
}

interface RfqExportSamplekit {
    name?: string;
    quantity?: number;
    value?: MoneyMessage;
    deleted: boolean;
}

export interface RfqExportRequest {
    orderNumber: string;
    type: string;
    vesselId: string;
    portId: string;
    customerId: string;
    supplierId: string;
    state: string;
    items: RfqExportItem[];
    samplekits?: RfqExportSamplekit[];
    dateDelivery?: string;
    agentId?: string;
    buyerReference?: string;
    offerIds?: string[];
}

export const exportOfferAsPdf = async ({ id }: ExportOfferAsPdfParams) =>
    authorizedAxiosInstance.post<Blob>(`/v2/export/offer/${id}`, undefined, { responseType: 'blob' });

export const exportOrderAsPdf = async ({ id }: ExportOrderAsPdfParams) =>
    authorizedAxiosInstance.post<Blob>(`/v2/export/order/${id}`, undefined, { responseType: 'blob' });

export const exportRfqAsPdf = async (request: RfqExportRequest) =>
    authorizedAxiosInstance.post<Blob>(`/v2/export/rfq`, request, { responseType: 'blob' });

export enum ReceiverType {
    VESSEL = 'VESSEL',
    COMPANY = 'COMPANY',
    AGENT = 'AGENT',
    OTHERS = 'OTHERS',
}

export interface ShareOfferRequestMessage {
    receiverEmailAddresses: string[];
    receiverTypes: ReceiverType[];
    copyToSelf: boolean;
}

interface ShareOfferParams {
    offerId: string;
    shareOfferRequestMessage: ShareOfferRequestMessage;
}

export const shareOffer = async ({ offerId, shareOfferRequestMessage }: ShareOfferParams) => {
    const response = await authorizedAxiosInstance.post(`/v2/export/offer/${offerId}/share`, shareOfferRequestMessage);

    return response.data;
};

interface ExportCustomerReportParams {
    customerGroupId?: string;
    dateDeliveryFrom: Iso8601DateTimeString;
    dateDeliveryTo: Iso8601DateTimeString;
}

export const exportCustomerReport = async (params: ExportCustomerReportParams): AxiosPromise<Blob> => {
    return await authorizedAxiosInstance.post(`/v1/export/customer-reports`, params, {
        responseType: 'blob',
    });
};

interface ExportEmergencyFillUpReportParams {
    customerGroupId: string;
    customerIds?: string[];
    dateDeliveryFrom: Iso8601DateTimeString;
    dateDeliveryTo: Iso8601DateTimeString;
}

export const exportEmergencyFillUpReport = async (params: ExportEmergencyFillUpReportParams): AxiosPromise<Blob> => {
    return await authorizedAxiosInstance.post(`/v1/export/emergency-fill-up-report`, params, {
        responseType: 'blob',
    });
};
